<template>
    <Breadcrumbs main="Uniform" title="Uniform Account" />
    <div class="container-fluid">
        <div class="card">
            <div class="card-header">
                <h5>Uniform Account Management</h5>
                <span>Track uniform inventory and transactions</span>
            </div>
            <div class="card-body">
                <uniform-account-table />
                <uniform-analysis />
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
import UniformAccountTable from '@/components/uniform-account/uniform-account-table.vue'
import UniformAnalysis from '@/components/uniform-account/uniform-analysis.vue'
</script>